import React from "react";
import { DetailsGrid, DetailRow, DetailLabel, DetailValue } from "../ConnectionDetails";
import { SiteFavicon, siteKind } from "./siteRow";
import { siteOption } from "./siteOptions";

export const SearchConsolePropertyDetails = ({ settings, accountOwner }) => {
    if (!settings.tokenName) return null;

    return (
        <DetailsGrid>
            <DetailRow>
                <DetailLabel>Google account</DetailLabel>
                <DetailValue>{accountOwner}</DetailValue>
            </DetailRow>
            {settings.siteUrl && (
                <DetailRow>
                    <DetailLabel>Property</DetailLabel>
                    <DetailValue>
                        <SiteFavicon siteUrl={settings.siteUrl} />
                        {siteOption(settings.siteUrl).displayName} ({siteKind(settings.siteUrl)})
                    </DetailValue>
                </DetailRow>
            )}
        </DetailsGrid>
    );
};
